import './modules/Logger';

// import bootstrap from './bootstrap.ui';
import './util/form-validation';
import './util/panes';
import './util/flash-storage';
import './pages/users';
import './pages/meals';
import './pages/mealitems';
import './pages/orders';
import './pages/reports';
import './pages/logs';
import './public/form';
import './public/checkout';

window.addEventListener('load', function() {
    // Initialize tooltips
    document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(el => new bootstrap.Tooltip(el));
});